import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "text-sm font-medium" }
const _hoisted_4 = {
  key: 0,
  class: "text-xs opacity-80"
}
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "toast" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
          return (_openBlock(), _createElementBlock("div", {
            key: toast.id,
            class: _normalizeClass(["pointer-events-auto min-w-[300px] rounded-lg border bg-white p-4 shadow-lg flex items-center gap-3 animate-in slide-in-from-right-full", [
          toast.type === 'error' ? 'border-red-200 bg-red-50 text-red-900' : 
          toast.type === 'success' ? 'border-green-200 bg-green-50 text-green-900' : 
          'border-gray-200 bg-white text-gray-900'
        ]])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(toast.message), 1),
              (toast.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(toast.description), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.remove(toast.id)),
              class: "text-lg leading-none opacity-50 hover:opacity-100"
            }, "×", 8, _hoisted_5)
          ], 2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}